import moment from "moment";

export default {
  allowedKeys: [
    "Temp",
    "temperature",
    "temp",
    "kWh",
    "wH",
    "Humidity",
    "humidity",
    "isOpen",
    "Light",
    "light",
    "Motion",
    "motion",
    "CO2",
    "co2",
    "waterDetectedInt",
    "SoundPeak",
    "sound_peak",
    "SoundAvg",
    "sound_avg",
    "parked",
    "cumulative_m3",
    "cumulative_l"
  ],
  translateions: {
    Temp: "Temperatur",
    temperature: "Temperatur",
    temp: "Temperatur",
    Humidity: "Feuchtigkeit",
    humidity: "Feuchtigkeit",
    isOpen: "Offen",
    Motion: "Bewegung",
    motion: "Bewegung",
    Light: "Licht",
    light: "Licht",
    SoundPeak: "Lautstärke",
    sound_peak: "Lautstärke",
    SoundAvg: "Lautstärke Durchschnitt letzte 15min",
    sound_avg: "Lautstärke Durchschnitt letzte 15min",
    parked: "Parkplatz",
    kWh: "Stromdaten",
    wH: "Stromdaten",
    cumulative_m3: "Wasserzähler",
    cumulative_l: "Wasserzähler"
  },
  parseDataForChart(row, packets, time) {
    let displayConfig;
    let units = [];
    let data = {};
    let format = "DD/MM";
    if (time === "1d") {
      format = "HH:00";
    }
    let packetData = this.sortPacketsByDate(packets, format);
    try {
      displayConfig = row.deviceType.niota_maps.display_config;
    } catch (err) {
      return null;
    }
    switch (displayConfig.config.deviceClassName) {
      case "holleymeter":
        units = ["kWh"];
        data = this.buildMeterData(packetData);
        data.selectOptions = this.buildSelectOptions(units, packetData.keys);
        data.keys = units;
        break;
      case "elsysThSensor": //Temperatursensor
        units = ["Temp", "Humidity"];
        data = this.buildDataObject(packetData, units);
        break;
      case "elsysTHCL": //Temperatur, Feuchtigkeits, Bewegungssensor, CO2 und Licht sensor
        units = ["motion", "light"];
        data = this.buildDataObject(packetData, units);
        break;
      case "elsysERS": //Schallsensor
        units = ["SoundAvg"];
        data = this.buildDataObject(packetData, units);
        break;
      case "elsysErsTHLM": //Temperatur, Feuchtigkeits, Licht und Bewegungssensor
        units = ["Light"];
        data = this.buildDataObject(packetData, units);
        break;
      case "adeunisDoorsensorBrandschott": //Brandschott sensor
        units = ["isOpen"];
        data = this.buildDataObject(packetData, units);
        break;
      case "adeunisWindowsensor": //Fenster kontaktsensor
        units = ["isOpen"];
        data = this.buildDataObject(packetData, units);
        break;
      case "ascoelDryContact": //tür kontakt
        units = ["TOR11"];
        data = this.buildDataObject(packetData, units);
        break;
      case "dzgDvs74": //Stromzähler
        units = ["wH"];
        data = this.buildMeterData(packetData);
        data.selectOptions = this.buildSelectOptions(units, packetData.keys);
        data.keys = units;
        break;
      case "sensingLabWaterLeak": //Feuchtigkeitssensor
        units = ["waterDetectedInt"];
        data = this.buildDataObject(packetData, units);
        break;
      case "boschParking": //Parking
        units = ["parked"];
        data = this.buildDataObject(packetData, units);
        break;
      case "feedbackTerminal": //feedback terminal
        units = ["var1", "var2", "var3", "var4"];
        data = this.buildDataObject(packetData, units);
        break;
      case "oiassettracker": //GPS Tracker
        units = ["temp"];
        data = this.buildDataObject(packetData, units);
        break;
      case "itronAquadis": //Water meter itron
        units = ["cumulative_l"];
        data = this.buildMeterData(packetData);
        data.selectOptions = this.buildSelectOptions(units, packetData.keys);
        data.keys = units;
        break;
      default:
        units = ["temp"];
        data = this.buildDataObject(packetData, units);
        break;
    }
    return data;
  },
  buildData(packetData) {
    let labels = {};
    let data = {};
    let avg = null;

    packetData.keys.forEach(key => {
      data[key] = [];
      labels[key] = [];
      for (var element in packetData.sortedPackets[key]) {
        labels[key].push(element);
        if (key == "Motion" || key == "motion") {
          avg = this.calculateMotions(packetData.sortedPackets[key][element]);
        } else {
          avg = this.arrayAverage(packetData.sortedPackets[key][element]);
        }
        data[key].push(avg);
      }
      labels[key].reverse();
      data[key].reverse();
    });
    return {
      labels: labels,
      data: data
    };
  },
  arrayAverage(array) {
    let sum = array.reduce((previous, current) => (current += previous));
    let avg = sum / array.length;
    return Math.floor(avg);
  },
  arraySum(array) {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    return array.reduce(reducer);
  },
  calculateMotions(array) {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    let sum = array.reduce(reducer);
    return sum;
  },
  sortPacketsByDate(packets, format) {
    let sortedPackets = [];
    let keys = Object.keys(packets);
    let types = [];
    keys.forEach(key => {
      if (this.allowedKeys.indexOf(key) != -1) {
        types.push(key);
        sortedPackets[key] = [];
        packets[key].forEach(item => {
          if (
            key === "Light" &&
            moment(item.time).hour() < 18 &&
            moment(item.time).hour() > 8
          ) {
            let date = moment(item.time).format(format);
            if (!Array.isArray(sortedPackets[key][date])) {
              sortedPackets[key][date] = [];
            }
            sortedPackets[key][date].push(0);
          } else {
            let date = moment(item.time).format(format);
            if (!Array.isArray(sortedPackets[key][date])) {
              sortedPackets[key][date] = [];
            }
            sortedPackets[key][date].push(item.orig_value);
          }
        });
      }
    });
    return { sortedPackets: sortedPackets, keys: types };
  },
  buildMeterData(packets) {
    let labels = {};
    let data = {};
    packets.keys.forEach(key => {
      data[key] = [];
      labels[key] = [];
      for (var element in packets.sortedPackets[key]) {
        let lastKey = packets.sortedPackets[key][element].length - 1;
        let first = packets.sortedPackets[key][element][0];
        let last = packets.sortedPackets[key][element][lastKey];
        let value = first - last;
        labels[key].push(element);
        data[key].push(value);
      }
      labels[key].reverse();
      data[key].reverse();
    });
    return {
      labels: labels,
      data: data
    };
  },
  buildSelectOptions(units, keys) {
    let options = [];
    keys.forEach(key => {
      if (this.allowedKeys.indexOf(key) != -1) {
        let text = key;
        if (units.indexOf(text) != -1) {
          if (key in this.translateions) {
            text = this.translateions[key];
          }
          let alreadyExists = options.find(element => element.text === text);
          if (!alreadyExists) {
            let option = {
              value: key,
              text: text
            };
            options.push(option);
          }
        }
      }
    });
    return options;
  },
  buildDataObject(packetData, units) {
    let data = this.buildData(packetData);
    data.selectOptions = this.buildSelectOptions(units, packetData.keys);
    data.keys = units;
    return data;
  }
};
